import { StockLotSchemaLite } from 'types/clientV2/stock';
import { AllocationQuerySchemaLite } from 'types/inventory';

export type StockLotForAllocationReasoning = Pick<
  StockLotSchemaLite,
  | 'id'
  | 'quant'
  | 'lotId'
  | 'v2OrgPart'
  | 'part'
  | 'facility'
  | 'team'
  | 'smtNoPnp'
  | 'quantCertain'
>;

export type AllocationForReasoning = Pick<
  AllocationQuerySchemaLite,
  | 'id'
  | 'quant'
  | 'stockLot'
  | 'kitRequestLine'
  | 'productionRun'
  | 'kitRequest'
>;

export type AllocationReason = {
  canAllocate: boolean;
  reason: string;
  reasonCode: AllocationReasonCode;
  allReasons?: string[];
};

export type DecoratedStockLot = StockLotForAllocationReasoning & {
  hasAllocation: boolean;
  allocatedQuantity: number;
  allocationReason: AllocationReason | null;
};

export enum AllocationReasonCode {
  TEAM_MISMATCH = 'TEAM_MISMATCH',
  TEAM_NULL_STOCK_LOT_ASSIGNED = 'TEAM_NULL_STOCK_LOT_ASSIGNED',
  TEAM_NULL_KIT_UNASSIGNED = 'TEAM_NULL_KIT_UNASSIGNED',
  TEAM_MATCH = 'TEAM_MATCH',
  LOCATION_MISMATCH = 'LOCATION_MISMATCH',
  LOCATION_MATCH = 'LOCATION_MATCH',
  SMT_NO_PNP = 'SMT_NO_PNP',
  QUANT_UNCERTAIN = 'QUANT_UNCERTAIN',
  ALREADY_ALLOCATED = 'ALREADY_ALLOCATED',
  CURRENTLY_ALLOCATED = 'CURRENTLY_ALLOCATED',
  LINE_LOCKED = 'LINE_LOCKED',
  AVAILABLE = 'AVAILABLE',
}
